import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ScrollingServerTable, TableRequest } from '@components/Table';
import { getUserActivityLog } from '@containers/Admin/containers/UserPage/services';
import { ActivityTable, Content, Page, PageHeader, Subtitle, TableCard, Title } from './styles';
import { ActivityLog } from './types';
import { columns } from './config';
import ActivityDetailsCard from './ActivityDetailsCard';
import { normalizeActivityTypes } from './helpers';

const UserActivityLogV2 = () => {
  const { id } = useParams<{ id: string }>();
  const [selected, setSelected] = useState<ActivityLog>();

  const fetchData = useCallback(
    async (options: TableRequest) => {
      const activities: ActivityLog[] = await getUserActivityLog(id, options);
      return { items: normalizeActivityTypes(activities) };
    },
    [id],
  );

  return (
    <Page>
      <PageHeader>
        <Title>User Activity Log</Title>
        <Subtitle>
          A record of everything that happened on this account, so you can see what a user did and when.
        </Subtitle>
      </PageHeader>
      <Content>
        <TableCard>
          <ActivityTable>
            <ScrollingServerTable
              columns={columns}
              fetchData={fetchData}
              getRowKey={(row) => row.id}
              minWidth={900}
              pageSize={50}
              initialSort={{ column: 'date', direction: 'DESC' }}
              itemLabel="activities"
              emptyMessage="No activities have been recorded."
              filteredEmptyMessage="No activities match these filters."
              loadingMessage="Loading activity log…"
              errorMessage="Could not load the activity log."
              selectedRowKey={selected?.id}
              onRowClick={setSelected}
            />
          </ActivityTable>
        </TableCard>
        <ActivityDetailsCard
          key={selected?.id}
          userId={id}
          activity={selected || null}
          activityId={selected?.activityId}
          externalId={selected?.externalId}
          activityType={selected?.type}
        />
      </Content>
    </Page>
  );
};

export default UserActivityLogV2;
